/** @format */
import { QRCodeSVG } from "qrcode.react";

const QRCode = ({ value, width = 100, height = 100 }) => {
  return <QRCodeSVG value={value} width={width} height={height} />;
};

export default QRCode;
